import React, { useState } from 'react';
import { Modal } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LoginView from '../Views/Login/Login';
import RegisterView from '../Views/Register/Register';
import { navModal, navModalMode } from '../../Actions/Page';
import ForgotPassword from '../Views/Login/ForgotPassword';
import QrCodeView from '../Views/QrCodeView';

const ModalApp = (props) => {
   const [loginClass, setLoginClass] = useState('');
   const [qrCodeClass, setQrCodeClass] = useState('');
   const [registerClass, setRegisterClass] = useState('');
   const [forgotPasswordClass, setForgotPasswordClass] = useState('');
   const [isQrCode, setIsQrCode] = useState(false);
   const [isForgotPassword, setIsForgotPassword] = useState(false);

   const toRegister = () => {
      setTimeout(() => {
         setRegisterClass('fadein');
         setLoginClass('fadeout');
      }, 1);
      setTimeout(() => {
         props.dispatch(
            navModalMode({
               loginModal: 0,
               registerModal: 1
            })
         );
      }, 1);
   };

   const toLogin = () => {
      setTimeout(() => {
         setLoginClass('fadein');
         setRegisterClass('fadeout');
      }, 1);
      setTimeout(() => {
         props.dispatch(navModalMode({ loginModal: 1, registerModal: 0 }));
      }, 1);
   };

   const endingForgetPassword = (boo) => {
      if (boo) {
         props.dispatch(navModal(false));
         setForgotPasswordClass('fadeout');
         setLoginClass('');
         props.dispatch(navModalMode({ loginModal: 0, registerModal: 0 }));
      }
   };

   const toForgetPassword = (boo) => {
      if (boo) {
         setTimeout(() => {
            setForgotPasswordClass('fadein');
            setLoginClass('fadeout');
         }, 1);
         setTimeout(() => {
            props.dispatch(
               navModalMode({
                  loginModal: 0,
                  registerModal: 0
               })
            );
            setIsForgotPassword(true);
         }, 1);
      } else {
         setTimeout(() => {
            setForgotPasswordClass('fadeout');
            setLoginClass('fadein');
         }, 1);
         setTimeout(() => {
            props.dispatch(
               navModalMode({
                  loginModal: 1,
                  registerModal: 0
               })
            );
            setIsForgotPassword(false);
         }, 1);
      }
   };
   const toQrcode = (boo) => {
      if (!boo) {
         setTimeout(() => {
            setQrCodeClass('fadeout');
            setLoginClass('fadein');
         }, 1);
         setTimeout(() => {
            props.dispatch(
               navModalMode({
                  loginModal: 1,
                  registerModal: 0
               })
            );
            setIsQrCode(false);
         }, 1);
      } else {
         setTimeout(() => {
            setQrCodeClass('fadein');
            setLoginClass('fadeout');
         }, 1);
         setTimeout(() => {
            props.dispatch(
               navModalMode({
                  loginModal: 0,
                  registerModal: 0
               })
            );
            setIsQrCode(true);
         }, 1);
      }
   };

   const modalConfig = {
      visible: true,
      footer: null,
      width: 500,
      className: 'modal-app',
      onCancel: () => {
         toQrcode(false);
         props.dispatch(navModal(false));
         setLoginClass('');
         setRegisterClass('');
         props.dispatch(navModalMode({ loginModal: 0, registerModal: 0 }));
      }
   };

   const renderModalContent = () => {
      if (props.registerModal) {
         return (
            <div className={registerClass}>
               <RegisterView {...props} toLogin={toLogin} isModal key={2} />
            </div>
         );
      }

      if (props.loginModal) {
         return (
            <div className={loginClass}>
               <LoginView
                  {...props}
                  toRegister={toRegister}
                  isModal
                  key={1}
                  toQrcode={toQrcode}
                  toForgetPassword={toForgetPassword}
               />
            </div>
         );
      }

      if (isQrCode) {
         return (
            <div className={qrCodeClass}>
               <QrCodeView isModal key={4} toQrcode={toQrcode} />
            </div>
         );
      }

      if (isForgotPassword) {
         return (
            <div className={forgotPasswordClass}>
               <ForgotPassword
                  isModal
                  key={5}
                  toForgetPassword={toForgetPassword}
                  endingForgetPassword={endingForgetPassword}
               />
            </div>
         );
      }

      return null;
   };

   if (!props.navModal) {
      return null;
   }

   return <Modal {...modalConfig}>{renderModalContent()}</Modal>;
};

const mapStateToProps = (state) => {
   return {
      navModal: state.Page.navModal,
      loginModal: state.Page.navModalMode.loginModal,
      registerModal: state.Page.navModalMode.registerModal
   };
};
export default withRouter(connect(mapStateToProps)(ModalApp));
